export const zIndexMobileMenu = 1
export const zIndexMobileMenuHeader = 2
export const zIndexMobileSidebar = 1
